import { Alignment, Fit, Layout, StateMachineInput, useRive, useStateMachineInput } from '@rive-app/react-canvas';
import React, { useEffect, useMemo, useState } from 'react';

import spinner from '../../../assets/animation/animated-spinner.riv';
import './index.css';

const STATE_MACHINE_NAME = 'state machine';

const AnimatedSpinnerComponent: React.FC<
  React.PropsWithChildren<{
    isLoaded?: boolean;
    onStopped?: () => void;
    animationName?: 'all' | 'all-loop' | 'cycle-loop';
    className?: string;
  }>
> = ({ isLoaded, onStopped, animationName = 'cycle-loop', className = '' }) => {
  const isLoadedDefined = useMemo(() => isLoaded !== undefined, [isLoaded]);

  const [wasEnabled, setWasEnabled] = useState(false);

  const { rive: riveInstance, RiveComponent } = useRive({
    src: spinner,
    animations: isLoadedDefined ? undefined : animationName,
    onStop: isLoadedDefined ? undefined : onStopped,
    autoplay: true,
    stateMachines: isLoadedDefined ? STATE_MACHINE_NAME : undefined,
    layout: new Layout({
      fit: Fit.Cover,
      alignment: Alignment.Center,
    }),
  });

  const isLoadedSMI: StateMachineInput | null = useStateMachineInput(riveInstance, STATE_MACHINE_NAME, 'loaded');

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (isLoadedSMI && isLoaded && !wasEnabled) {
      isLoadedSMI.value = isLoaded;
      setWasEnabled(true);
      timeoutId = setTimeout(() => {
        onStopped?.();
        clearTimeout(timeoutId);
      }, 2500);
    }
  }, [isLoaded, isLoadedSMI, onStopped, wasEnabled]);

  return (
    <div className={`animated-spinner ${className}`}>
      <RiveComponent className='animated-spinner__rive-comp' />
    </div>
  );
};

export default React.memo(AnimatedSpinnerComponent);
